// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"669":"98962e6c","787":"edef6f50"}[chunkId] + ".chunk.js";
};